<div class="filter-error-container"> 
  <h1 class="title">
    Sorry, something went wrong. We’re having trouble loading the page.
  </h1>
  <h2 class="details">
    Please try refreshing the page. 
  </h2>
</div>